import { parse } from 'tldts'

export default defineNuxtRouteMiddleware(async () => {
  const { brand, getBrand } = useBrandStore()

  const origin = useRequestURL().origin

  const parsed = origin ? parse(origin) : null

  const hasSubdomain = parsed?.subdomain || (parsed?.publicSuffix === 'localhost' && parsed.domainWithoutSuffix)

  if (!hasSubdomain || brand) return

  try {
    const response = await getBrand(origin)

    if (response?.brand?.portalCssPath) {
      await new Promise<void>((resolve, reject) => {
        const link = document.createElement('link')

        link.rel = 'stylesheet'
        link.href = `${useRuntimeConfig().public.BLOB_URL}/${response.brand.portalCssPath}`

        link.onload = () => resolve()
        link.onerror = () => reject(new Error('Failed to load brand CSS'))

        document.head.appendChild(link)
      })
    }
  } catch (error) {
    console.error('Error fetching brand:', error)
  }
})
